<template>
  <b-col class="p-0 history-wrapper">
    <b-card header="Historial de Estados" class="my-3" header-bg-variant="primary">
      <b-table
        class="history-table"
        striped
        :items="flattenedHistory"
        hover
        outlined
        head-variant='light'
        :fields="fields"
        :small="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        empty-text="No hay historial de estados para mostrar"
        >
          <template slot="site" slot-scope="row">
            {{row.item.site}}
          </template>
          <template slot="user" slot-scope="row">
            {{row.item.user ? row.item.user.firstName : ''}} {{row.item.user ? row.item.user.lastName : ''}}
          </template>
          <template slot="date" slot-scope="row">
            {{new Date(row.item.creationDate).toLocaleDateString(locale)}}
            {{new Date(row.item.creationDate).toLocaleTimeString(locale)}}
          </template>
          <template slot="oldStatus" slot-scope="row">
            <b v-if="row.item.oldStatus === 'APPROVED'" class="text-success">
              {{$t(getStatusText(row.item.oldStatus))}}
            </b>
            <b v-else-if="row.item.oldStatus === 'REJECTED'" class="text-danger">
              {{$t(getStatusText(row.item.oldStatus))}}
            </b>
            <b v-else-if="row.item.oldStatus === 'PENDING_APPROVAL'" class="text-warning">
              {{$t(getStatusText(row.item.oldStatus))}}
            </b>
            <span v-else>{{$t('N/A')}}</span>
          </template>
          <template slot="status" slot-scope="row">
            <b v-if="row.item.status === 'APPROVED'" class="text-success">
              {{$t(getStatusText(row.item.status))}}
            </b>
            <b v-else-if="row.item.status === 'REJECTED'" class="text-danger">
              {{$t(getStatusText(row.item.status))}}
            </b>
            <b v-else-if="row.item.status === 'PENDING_APPROVAL'" class="text-warning">
              {{$t(getStatusText(row.item.status))}}
            </b>
          </template>

      </b-table>
    </b-card>
  </b-col>
</template>
<script>
import appConfig from '@/config/applicationConfig.js'
import { PRODUCT_STATES } from '@/mixims/ProductServiceMixim.js'

export default {
  name: 'SkuStatusHistory',
  props: {
    marketplaces: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fields: [
        { key: 'user', label: 'Usuario', 'class': 'text-left' },
        { key: 'date', label: 'Fecha', 'class': 'text-left'},
        { key: 'site', label: 'Sitio', 'class': 'text-left'},
        { key: 'oldStatus', label: 'Estado anterior', 'class': 'text-left' },
        { key: 'status', label: 'Nuevo estado', 'class': 'text-left' }
      ],
      sortBy: 'date',
      sortDesc: true,
      locale: appConfig.LOCALE,
      productStates: PRODUCT_STATES
    }
  },
  computed: {
    flattenedHistory () {
      let rows = []
      this.marketplaces.forEach(mkt => {
        const entries = [...(mkt.skuStatusHistory || [])].sort(
          (a, b) => new Date(a.creationDate) - new Date(b.creationDate)
        )
        entries.forEach((entry, index) => {
          rows.push({
            site: mkt.name || mkt.id,
            user: entry.user,
            creationDate: entry.creationDate,
            oldStatus: index > 0 ? entries[index - 1].status : null,
            status: entry.status
          })
        })
      })
      return rows
    }
  },
  methods: {
    getStatusText (status) {
      const found = this.productStates.find(p => p.value === status)
      return found ? found.text : status
    }
  }
}
</script>

<style lang="scss" scoped>
  .history-wrapper {
    .card-body {
      max-height: 300px;
      overflow-y: auto;
    }
    div.card{
      border-bottom-color: transparent;
    }
  }
</style>